import { render, staticRenderFns } from "./ConfirmLogoutDialog.vue?vue&type=template&id=80e3e43c&scoped=true"
import script from "./ConfirmLogoutDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmLogoutDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e3e43c",
  null
  
)

export default component.exports